import React, { useState, useEffect } from "react";
import "./Layout.css";
import { Link } from "react-router-dom";
import ArrowBack from '../../../images/arrow-back.svg'
import CompareAssessmentsButton from "../../../_components/common/CompareAssessmentsButton/CompareAssessmentsButton";
import { useMobileStatus } from "../../Utils/useMobileStatus";

const Dashboardcardlayout = (props) => {

  const isMobile = useMobileStatus();
  const filterData = JSON.parse(localStorage.getItem("filterData"));

 


  const isAssessmentReport = window.location.pathname.endsWith('/assessment-report');
  const isAssessmentReportButton = window.location.pathname.endsWith('/new/app/reports/:id');

  const userType = localStorage.getItem("usertype");




 

  return (
    <React.Fragment>
      <section className="dashboard-wrapper">
        <div style={isAssessmentReport ? { paddingTop: '0px' } : {}} className="card-layout">
          {props.isExtra ? (
            <div>
              <div className="hederWrapper1">
                <div className="header">
                  <img
                    className="headerIcon"
                    src={props.headerIcon}
                    alt="dashboard icon"
                  />

                  <h1 className="headerText">{props.headerText}</h1>
                </div>
            

                <div style={{ display: "flex", justifyContent: "center" }}>
                  {!userType.includes("seller_admin") && !userType.includes("organisation_admin") && (
                    <CompareAssessmentsButton />
                  )}


                </div>


              </div>
              <hr style={{ color: "grey" }} />
            </div>
          ) : null}{" "}
          {props.CompareAssessment ? (
            <div>
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <div className="header">
                  <img
                    style={{
                      marginLeft: isMobile && window.location.pathname === '/new/app/compare-assessment' ? '-21px' : '0',
                    }}

                    className="headerIcon"
                    src={props.headerIcon}
                    alt="dashboard icon"
                  />

                  <h1 className="headerText">{props.headerText}</h1>
                </div>
              </div>
              <hr style={{ borderColor: "grey" }} />
            </div>
          ) : null}
          {props.assessmentList ? (
            <div>
              <div style={{
                display: "flex",
                flexDirection: isMobile ? "column" : "row",
                justifyContent: "space-between"
              }}>
                <div className="header">
                  <img
                    className="headerIcon"
                    src={props.headerIcon}
                    alt="dashboard icon"
                  />

                  <h1 className="headerText">{props.headerText}</h1>
                </div>

              </div>
              <hr style={{ borderColor: "grey" }} />
            </div>
          ) : null}
          {props.reportPage ? (
          
            <div>
              {isAssessmentReport && (
                <Link to="/new/app/assessment">
                  <img
                    src={ArrowBack}
                    alt="arrow-back"
                    style={{ marginTop: '13px', cursor: 'pointer' }}
                  />
                </Link>
              )}


              <div style={{ display: "flex", justifyContent: "space-between", flexDirection: isMobile ? "column" : "row" }}>
                <div className="header">
                  <img
                    className="headerIcon"
                    src={props.headerIcon}
                    alt="dashboard icon"
                  />

                  <h1 className="headerText">{props.headerText}</h1>
                </div>
                <div className="headerHolder">

                 
                  <div
                    className="orientationClass"
                  >
                    <span>{filterData.formData.dropdown2}</span>
                  </div>
                  {filterData && filterData.formData.orientation && filterData.formData.orientation.length > 0 && (
                    <div className="orientationClass">
                      <span>{filterData.formData.orientation.join(", ")}</span>
                    </div>
                  )}
                  {filterData && filterData.formData.dropdown2 === "LOI 360" && filterData.formData.relation && (
                    <div className="orientationClass">
                      <span>{filterData.formData.relation}</span>
                    </div>
                  )}

                </div>
              </div>
              <hr style={{ borderColor: "grey" }} />
            </div>
          ) : null}
          {!props.CompareAssessment &&
            !props.isExtra &&
            !props.assessmentList &&
            !props.reportPage ? (
            isAssessmentReportButton ? (
              // If the current location matches "/new/app/reports/:id"
              <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <div className="header">
                  <img
                    className="headerIcon"
                    src={props.headerIcon}
                    alt="dashboard icon"
                  />
                  <h1 className="headerText">{props.headerText}</h1>
                </div>
                <div style={{ display: 'flex', alignItems: 'center', fontSize: 'x-small' }}>
                  {!userType.includes("seller_admin") && !userType.includes("organisation_admin") && (
                    <CompareAssessmentsButton />
                  )}


                </div>
              </div>
            ) : (
              // Else, render without CompareAssessmentsButton
              <div className="header">
                <img
                  className="headerIcon"
                  src={props.headerIcon}
                  alt="dashboard icon"
                />
                <h1 className="headerText">{props.headerText}</h1>
              </div>
            )

          ) : null}
          <div>{props.children}</div>
        </div>
      </section>
    </React.Fragment>
  );
};

export default Dashboardcardlayout;



// WEBPACK FOOTER //
// ./src/new/Components/Layout/Layout.jsx